(function(){
  if(window.__jjmMembers)return;window.__jjmMembers=1;
  var KEY='jjm_last_course',NAV='jjm_nav_',UUID='[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
  var RE_LESSON=new RegExp('^/a/members/('+UUID+')/('+UUID+')/?$');
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function store(k,v){try{localStorage.setItem(k,v)}catch(e){}}
  function read(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function ids(h){var m=(h||'').match(new RegExp('/a/members/('+UUID+')(?:/('+UUID+'))?'));return m?{c:m[1],l:m[2]||null}:{c:null,l:null}}
  function shortName(t){return String(t||'').replace(/\s*-\s*FULL COURSE/i,'').replace(/^The\s+/i,'').trim()}
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return [].slice.call((r||document).querySelectorAll(s))}
  // stop a redraw that keeps repeating (protects against fighting with Tevello's own updates)
  var G={};function guard(k){var t=Date.now();G[k]=(G[k]||[]).filter(function(x){return t-x<3000});G[k].push(t);return G[k].length<=4}

  // ---------- course data (outline + completed lessons), cached per course on this device ----------
  var S={},inflight={};
  function slim(j){return {title:(j.title||'').trim(),img:(j.image&&j.image.file)||'',
    modules:(j.modules||[]).filter(function(m){return m.visibility!=='hidden'}).map(function(m){return {title:(m.title||'').trim(),lessons:(m.lessons||[]).filter(function(l){return l.visibility!=='hidden'}).map(function(l){return {id:l.id,title:(l.title||'').trim()}})}}),
    progress:j.progress||[]}}
  function data(c){if(S[c])return S[c];try{var v=JSON.parse(read(NAV+c));if(v&&v.modules&&v.modules.length)return S[c]=v}catch(e){}return null}
  function fresh(c,l,cb){
    var k=c+'/'+l;if(inflight[k])return;inflight[k]=1;
    fetch('/a/members/api/courses/'+c+'/'+l+'/beta_navigation',{credentials:'same-origin',headers:{accept:'application/json'}})
      .then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(j){var s=slim(j);if(!s.modules.length)throw 0;var prev=data(c);if(prev&&!s.title&&prev.title)s.title=prev.title;S[c]=s;store(NAV+c,JSON.stringify(s));if(cb)cb(s,prev);schedule()})
      .catch(function(){}).then(function(){delete inflight[k]});
  }
  function shape(c,lid,s){
    var done={};s.progress.forEach(function(id){done[id]=1});
    var chs=s.modules.map(function(m){var ls=m.lessons.map(function(l){return {id:l.id,t:l.title,h:'/a/members/'+c+'/'+l.id,done:!!done[l.id]}});var n=ls.filter(function(l){return l.done}).length;return {name:m.title,lessons:ls,n:n,state:ls.length&&n===ls.length?'done':n?'part':''}});
    var flat=[];chs.forEach(function(ch,ci){ch.lessons.forEach(function(l){flat.push({id:l.id,t:l.t,h:l.h,done:l.done,ci:ci,ch:ch.name})})});
    var i=-1;flat.forEach(function(l,k){if(i<0&&l.id===lid)i=k});
    if(i<0)flat.forEach(function(l,k){if(i<0&&!l.done)i=k});
    return {chs:chs,flat:flat,i:Math.max(i,0),nDone:flat.filter(function(l){return l.done}).length};
  }

  // ---------- celebration ----------
  function celebrate(label,title){
    var old=document.getElementById('jjm-toast');if(old)old.remove();
    var t=document.createElement('div');t.id='jjm-toast';t.innerHTML='<span class="ic"></span><span><small>'+esc(label)+'</small><b>'+esc(title)+'</b></span>';document.body.appendChild(t);
    var cols=['#FB4949','#F8B703','#0A2041','#FF7A59','#ffffff'];
    for(var k=0;k<90;k++){var c=document.createElement('i');c.className='jjm-conf';c.style.left=(Math.random()*100)+'vw';c.style.background=cols[k%5];c.style.animationDuration=(1.8+Math.random()*1.8)+'s';c.style.animationDelay=(Math.random()*.5)+'s';document.body.appendChild(c);(function(c){setTimeout(function(){c.remove()},4500)})(c)}
    setTimeout(function(){t.remove()},4000);
  }

  // ---------- dashboard (/a/members) ----------
  function badges(cards){
    cards.forEach(function(c){
      if(c.querySelector('.jjm-badge'))return;
      var t=($('.tw-card-title',c)||{}).textContent||'',p=+c.dataset.progress,b=null;
      if(c.classList.contains('not-enrolled')&&/2\.0/.test(t))b=['new','Sneak peek'];
      else if(p>0)b=['prog','In progress'];
      else if(/free/i.test(t))b=['free','Free'];
      var f=$('figure',c);
      if(b&&f){var e=document.createElement('span');e.className='jjm-badge '+b[0];e.textContent=b[1];f.appendChild(e)}
    });
  }
  function cardLine(x,s){
    var o=shape(x.ids.c,x.ids.l,s),L=o.flat[o.i],pr=$('progress',x.el);
    if(!(x.p>0)||!pr||!L)return;
    var u=$('.jjm-upnext',x.el);
    if(!u){u=document.createElement('div');u.className='jjm-upnext';pr.insertAdjacentElement('beforebegin',u)}
    var html='<span>Up next: <b>'+esc(L.t)+'</b></span>';if(u.innerHTML!==html)u.innerHTML=html;
  }
  var dash={curK:-1,tabs:null};
  function dashboard(){
    var title=$('h1.courses-title'),cards=$$('.courses a.tw-card');
    if(!title||!cards.length)return;
    badges(cards);
    var hero=document.getElementById('jjm-hero');
    if(hero&&hero.isConnected&&hero.previousElementSibling===title)return;
    if(!guard('dash'))return;
    if(hero)hero.remove();var om=document.getElementById('jjm-map');if(om)om.remove();
    var info=cards.filter(function(c){return c.classList.contains('enrolled')}).map(function(c){
      var h=c.getAttribute('href');
      return {el:c,href:h,ids:ids(h),p:+c.dataset.progress||0,t:(($('.tw-card-title',c)||{}).textContent||'').trim(),img:($('img',c)||{}).src||''};
    });
    if(!info.length)return;
    var tabs=info.filter(function(x){return x.p>0||/full course/i.test(x.t)}).sort(function(a,b){return b.p-a.p}).slice(0,3);
    if(!tabs.length)tabs=[info[0]];
    var last=read(KEY),start=0;tabs.forEach(function(x,k){if(x.ids.c===last)start=k});
    dash.tabs=tabs;
    if(title.textContent!=='Welcome back')title.textContent='Welcome back';
    hero=document.createElement('section');hero.id='jjm-hero';hero.className='jjm-sec';
    hero.innerHTML='<div class="bg"></div><div class="shade"></div>'+
      (tabs.length>1?'<div class="tabs">'+tabs.map(function(x,k){return '<button type="button" class="tab" data-k="'+k+'">'+esc(shortName(x.t))+'</button>'}).join('')+'</div>':'')+
      '<div class="in"><div class="txt"></div><div class="ring"><svg viewBox="0 0 170 170"><circle cx="85" cy="85" r="72" stroke="rgba(255,255,255,.12)" stroke-width="12" fill="none"/><circle class="arc" cx="85" cy="85" r="72" stroke="url(#jjmg)" stroke-width="12" fill="none" stroke-linecap="round" stroke-dasharray="452.4" stroke-dashoffset="452.4"/><defs><linearGradient id="jjmg"><stop offset="0" stop-color="#FB4949"/><stop offset="1" stop-color="#F8B703"/></linearGradient></defs></svg><div class="val"><span>0%</span><small>COMPLETE</small></div></div><div class="queue"></div></div>';
    var map=document.createElement('section');map.id='jjm-map';map.className='jjm-sec';map.style.display='none';
    title.insertAdjacentElement('afterend',hero);hero.insertAdjacentElement('afterend',map);
    function basic(x){
      var name=shortName(x.t);
      $('.txt',hero).innerHTML='<div class="fade"><span class="eyebrow"><i></i>'+(x.p>0?'Continue ':'Start ')+esc(name)+'</span><h2>'+esc(name)+'</h2><div class="meta"><span class="chip">'+x.p+'% complete</span></div><a class="jjm-cta" href="'+esc(x.href)+'"><span class="play">&#9654;</span> '+(x.p>0?'Resume course':'Start course')+'</a></div>';
      $('.queue',hero).innerHTML='';map.style.display='none';
    }
    function detail(x,s,anim){
      var o=shape(x.ids.c,x.ids.l,s),L=o.flat[o.i],name=shortName(x.t);if(!L)return basic(x);
      var f=anim?' class="fade"':'';
      $('.txt',hero).innerHTML='<div'+f+'><span class="eyebrow"><i></i>Up next in '+esc(name)+'</span><h2>'+esc(L.t)+'</h2><div class="meta"><span class="chip">Chapter '+(L.ci+1)+': '+esc(L.ch)+'</span><span class="chip">'+o.nDone+' of '+o.flat.length+' lessons done</span></div><a class="jjm-cta" href="'+esc(L.h)+'"><span class="play">&#9654;</span> Play lesson</a></div>';
      var next=[L].concat(o.flat.slice(o.i+1).filter(function(l){return !l.done})).slice(0,4);
      if(next.length<4)next=next.concat(o.flat.slice(0,o.i).filter(function(l){return !l.done})).slice(0,4);
      $('.queue',hero).innerHTML='<div'+f+'><div class="k">YOUR QUEUE</div>'+next.map(function(l,j){return '<a class="q'+(j?'':' now')+'" href="'+esc(l.h)+'"><em>'+(o.flat.indexOf(l)+1)+'</em><span>'+esc(l.t)+'<small>'+esc(l.ch)+'</small></span></a>'}).join('')+'</div>';
      map.style.display='';
      map.innerHTML='<div class="k">Your path through '+esc(name)+'</div><div class="scroll"><div class="track"><div class="line"></div>'+
        o.chs.map(function(c,ci){var first=c.lessons[0];return '<a class="st '+(ci===L.ci?'cur ':'')+c.state+'" href="'+esc(first?first.h:x.href)+'" title="'+esc(c.name)+'"><i></i>'+esc(c.name)+'</a>'}).join('')+'</div></div><div class="legend"><span class="d"><i></i>Done</span><span class="p"><i></i>Started</span><span><i></i>Not started</span></div>';
      var cur=$('.st.cur',map),sc=$('.scroll',map);
      if(cur&&sc&&sc.scrollWidth>sc.clientWidth)sc.scrollLeft=Math.max(0,cur.offsetLeft-sc.clientWidth/2);
      cardLine(x,s);
    }
    function show(k){
      dash.curK=k;var x=tabs[k];
      $$('.tab',hero).forEach(function(b){b.classList.toggle('on',+b.dataset.k===k)});
      $('.bg',hero).style.backgroundImage='url("'+x.img.replace(/"/g,'%22')+'")';
      $('.arc',hero).style.strokeDashoffset=452.4*(1-x.p/100);
      $('.val span',hero).textContent=x.p+'%';
      var c=data(x.ids.c);
      if(c)detail(x,c,true);else basic(x);
      if(x.ids.l)fresh(x.ids.c,x.ids.l,function(s){if(dash.curK===k&&hero.isConnected)detail(x,s,!c)});
    }
    hero.addEventListener('click',function(e){var b=e.target.closest('.tab');if(b){var k=+b.dataset.k;store(KEY,tabs[k].ids.c);show(k)}});
    show(start);
    tabs.forEach(function(x,k){if(k===start)return;var c=data(x.ids.c);if(c)cardLine(x,c);if(x.ids.l)fresh(x.ids.c,x.ids.l,function(s){if(x.el.isConnected)cardLine(x,s)})});
  }

  // ---------- lesson page (/a/members/{course}/{lesson}) ----------
  var lastLesson=null;
  function lesson(c,lid){
    var main=$('.lesson-content'),drawer=$('.tw-drawer');
    if(!main||!drawer)return;
    if(lastLesson!==c+'/'+lid){lastLesson=c+'/'+lid;fresh(c,lid)}
    var s=data(c),o=s?shape(c,lid,s):null,L=o?o.flat[o.i]:null;if(L&&L.id!==lid)L=null;
    var h1=$('h1',main),domTitle=h1?h1.textContent.trim():'',courseTitle=(($('.sidbar-title')||{}).textContent||'').trim();
    var pctDom=parseInt((($('.tw-percentage')||{}).textContent||'').trim(),10);
    var pct=o?(o.flat.length?Math.round(o.nDone/o.flat.length*100):0):(isNaN(pctDom)?0:pctDom);
    var name=shortName((s&&s.title)||courseTitle);
    var sig=[lid,pct,o?o.nDone:'-',domTitle,name].join('|');
    var b=document.getElementById('jjm-lband');
    var known={};if(o)o.flat.forEach(function(l){known[l.id]=1});
    var sideOk=!o||$$('.sidebar-inner li > a[href*="/a/members/"]').every(function(a){return a.classList.contains('jjm-ckd')||!known[ids(a.getAttribute('href')).l]});
    var nv=document.getElementById('jjm-lnav');
    var navOk=(o&&L)?!!(nv&&nv.isConnected&&nv.dataset.sig===sig):!nv;
    if(b&&b.isConnected&&b.dataset.sig===sig&&b.nextElementSibling===drawer&&sideOk&&navOk)return;
    if(!guard('l'+sig))return;

    // header band
    if(!b){b=document.createElement('section');b.id='jjm-lband'}
    b.dataset.sig=sig;
    var CIRC=289.03;
    b.innerHTML='<div class="bg"'+(s&&s.img?' style="background-image:url(&quot;'+esc(s.img)+'&quot;)"':'')+'></div><div class="shade"></div><div class="in"><div class="txt">'+
      '<a class="crumb" href="/a/members">&#8592; My courses'+(name?' <span>/</span> <b>'+esc(name)+'</b>':'')+'</a>'+
      '<h1>'+esc(L?L.t:domTitle)+'</h1>'+
      (L?'<div class="chips"><span class="chip">Chapter '+(L.ci+1)+': '+esc(L.ch)+'</span><span class="chip">Lesson '+(o.i+1)+' of '+o.flat.length+'</span>'+(L.done?'<span class="chip ok">&#10003; Completed</span>':'')+'</div>':'')+
      '</div><div class="side"><div class="ring"><svg viewBox="0 0 112 112"><circle cx="56" cy="56" r="46" stroke="rgba(255,255,255,.12)" stroke-width="9" fill="none"/><circle cx="56" cy="56" r="46" stroke="url(#jjmlg)" stroke-width="9" fill="none" stroke-linecap="round" stroke-dasharray="'+CIRC+'" stroke-dashoffset="'+(CIRC*(1-pct/100))+'"/><defs><linearGradient id="jjmlg"><stop offset="0" stop-color="#FB4949"/><stop offset="1" stop-color="#F8B703"/></linearGradient></defs></svg><div class="val">'+pct+'%<small>COMPLETE</small></div></div>'+(o?'<div class="done">'+o.nDone+' of '+o.flat.length+' lessons</div>':'')+'</div></div>';
    if(b.nextElementSibling!==drawer)drawer.parentElement.insertBefore(b,drawer);

    // mobile lessons button label
    $$('label.tw-drawer-button').forEach(function(lb){lb.setAttribute('data-jjm',o?'Lessons · '+o.nDone+'/'+o.flat.length:'Lessons')});

    // complete button wrapper + nav bar (Tevello's button stays where it is)
    var cbtn=$$('a.tw-btn-primary',main).filter(function(a){return /complete/i.test(a.textContent)})[0];
    var cw=null;if(cbtn){cw=cbtn;while(cw.parentElement&&cw.parentElement!==main)cw=cw.parentElement;if(cw.parentElement!==main)cw=null}
    if(cw)cw.classList.add('jjm-cwrap');
    var nav=document.getElementById('jjm-lnav');
    if(o&&L){
      if(!nav){nav=document.createElement('div');nav.id='jjm-lnav'}
      var P=o.flat[o.i-1],N=o.flat[o.i+1];
      nav.dataset.sig=sig;
      nav.innerHTML=(P?'<a class="prev" href="'+esc(P.h)+'">&#8592; <span>Previous</span></a>':'<span class="prev off">&#8592; <span>Previous</span></span>')+
        (N?'<a class="next" href="'+esc(N.h)+'"><span class="t"><small>Up next</small><b>'+esc(N.t)+'</b></span><span class="arr">&#8594;</span></a>':'<span class="next"><span class="t"><small>Last lesson</small><b>You made it to the end</b></span></span>');
      if(cw){if(nav.nextElementSibling!==cw)main.insertBefore(nav,cw)}else if(nav.parentElement!==main)main.appendChild(nav);
    }else if(nav)nav.remove();

    // sidebar checklist
    if(o){
      var byId={};o.flat.forEach(function(l,k){byId[l.id]=k});
      $$('.sidebar-inner li > a[href*="/a/members/"]').forEach(function(a){
        var id=ids(a.getAttribute('href')).l,k=byId[id];if(k==null)return;
        var l=o.flat[k],ck=$('.jjm-ck',a);
        if(!ck){ck=document.createElement('span');a.insertBefore(ck,a.firstChild)}
        var cls='jjm-ck'+(l.done?' on':'')+(l.id===lid&&!l.done?' now':''),txt=l.done?'':String(k+1);
        if(ck.className!==cls)ck.className=cls;if(ck.textContent!==txt)ck.textContent=txt;
        a.classList.add('jjm-ckd');a.classList.toggle('jjm-isdone',l.done);
      });
      $$('.sidebar-inner li.menu-title').forEach(function(li,ci){
        var ch=o.chs[ci];if(!ch)return;
        var cc=$('.jjm-chc',li);
        if(!cc){cc=document.createElement('span');var sv=$('svg',li);if(sv)sv.parentNode.insertBefore(cc,sv);else li.appendChild(cc)}
        var cls='jjm-chc'+(ch.state==='done'?' full':''),txt=ch.n+'/'+ch.lessons.length;
        if(cc.className!==cls)cc.className=cls;if(cc.textContent!==txt)cc.textContent=txt;
      });
    }
  }
  function celebrateDiff(c,s,prev){
    if(!prev||!prev.progress)return;
    var before={};prev.progress.forEach(function(id){before[id]=1});
    var now={};s.progress.forEach(function(id){now[id]=1});
    var gained=s.progress.filter(function(id){return !before[id]});if(!gained.length)return;
    var all=s.modules.reduce(function(a,m){return a.concat(m.lessons)},[]);
    var wasAll=all.length&&all.every(function(l){return before[l.id]}),isAll=all.length&&all.every(function(l){return now[l.id]});
    if(isAll&&!wasAll){celebrate('COURSE COMPLETE',shortName(s.title)||'You finished the course');return}
    for(var i=0;i<s.modules.length;i++){var m=s.modules[i];if(!m.lessons.length)continue;
      var was=m.lessons.every(function(l){return before[l.id]}),is=m.lessons.every(function(l){return now[l.id]});
      if(is&&!was){celebrate('CHAPTER COMPLETE',m.title+': '+m.lessons.length+' of '+m.lessons.length+' lessons');return}}
  }

  // ---------- router ----------
  function cleanup(keep){
    if(keep!=='dash'){document.documentElement.classList.remove('jjm-mh');['jjm-hero','jjm-map'].forEach(function(i){var e=document.getElementById(i);if(e)e.remove()})}
    if(keep!=='lesson'){document.documentElement.classList.remove('jjm-ls');['jjm-lband','jjm-lnav'].forEach(function(i){var e=document.getElementById(i);if(e)e.remove()});lastLesson=null}
  }
  function route(){
    try{
      var p=location.pathname.replace(/\/+$/,''),m;
      if(p==='/a/members'){cleanup('dash');document.documentElement.classList.add('jjm-mh');dashboard()}
      else if((m=location.pathname.match(RE_LESSON))){cleanup('lesson');document.documentElement.classList.add('jjm-ls');lesson(m[1],m[2])}
      else cleanup('');
    }catch(e){if(window.console)console.warn('jjm members',e)}
  }
  var pending=false;
  function schedule(){if(pending)return;pending=true;setTimeout(function(){pending=false;route()},30)}

  // remember last course; celebrate on the click that completes a chapter/course
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href*="/a/members/"]');
    if(a){var c=ids(a.getAttribute('href')).c;if(c)store(KEY,c)}
    var btn=e.target.closest&&e.target.closest('.lesson-content a.tw-btn-primary');
    var m=location.pathname.match(RE_LESSON);
    if(btn&&m&&/complete/i.test(btn.textContent)){
      var s=data(m[1]);if(!s)return;
      if(s.progress.indexOf(m[2])<0){var prev={progress:s.progress.slice()};s.progress=s.progress.concat([m[2]]);store(NAV+m[1],JSON.stringify(s));celebrateDiff(m[1],s,prev)}
    }
  },true);
  ['pushState','replaceState'].forEach(function(fn){var o=history[fn];history[fn]=function(){var r=o.apply(this,arguments);schedule();return r}});
  window.addEventListener('popstate',schedule);
  function boot(){route();new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
